module.exports = __webpack_public_path__ + "static/media/project2019.d44e6277.png";